import React from 'react';
import { CTAButton } from './CTAButton';
export function EmotionalBlock() {
  return <section className="w-full bg-sand-100 py-24 md:py-32 px-6" data-id="element-58">
      <div className="max-w-2xl mx-auto" data-id="element-59">
        <p className="font-serif text-2xl md:text-3xl text-charcoal-700 mb-12 text-center leading-relaxed" data-id="element-60">
          Si estás embarazada o ya tenés a tu bebé…
          <br data-id="element-61" />
          <span className="italic text-charcoal-400" data-id="element-62">
            quizás estés sintiendo:
          </span>
        </p>

        <div className="mb-16 pl-4 md:pl-12" data-id="element-63">
          <ul className="space-y-6 text-lg md:text-xl text-charcoal-500 font-light" data-id="element-64">
            {['Que todo es nuevo y abrumador', 'Que dudás más de lo que te gustaría', 'Que la información no te da tranquilidad', 'Que querés hacerlo bien… pero no sabés por dónde empezar'].map((item, index) => <li key={index} className="flex items-start gap-6" data-id="element-65">
                <span className="text-sage-500 mt-1.5 text-sm" data-id="element-66">●</span>
                <span className="leading-relaxed" data-id="element-67">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-16" data-id="element-68">
          <p className="font-serif text-2xl md:text-3xl text-warm-500 mb-2" data-id="element-69">
            No es falta de amor.
          </p>
          <p className="font-serif text-2xl md:text-3xl text-charcoal-700" data-id="element-70">
            Es falta de una guía clara.
          </p>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-71">
          <CTAButton href="#compra" data-id="element-72">Quiero sentirme acompañada</CTAButton>
        </div>
      </div>
    </section>;
}